export const NO_DATA_COLOR = '#B8BFCC';
